// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appName: 'Kinerja',
  production: false,
  prod: {
    baseUrl: 'https://apitpp.badungkab.dev/',
    apiUrl: 'https://apitpp.badungkab.dev/api/',
    imageUrl: 'https://apitpp.badungkab.dev/storage',
    sso: {
      clientId: 'sikap-app',
      issuer: 'https://iam.badungkab.dev/realms/badung-apps',
    },
  },
  demo: {
    baseUrl: 'https://apitpp.badungkab.dev/',
    apiUrl: 'https://apitpp.badungkab.dev/api/',
    imageUrl: 'https://apitpp.badungkab.dev/storage',
    sso: {
      clientId: 'sikap-app',
      issuer: 'https://iam.badungkab.dev/realms/badung-apps',
    },
  },
  useLocal: true,
  enableDebug: false,
  mapKey: 'AIzaSyAovhxjkjJX16jhgBhuFGJTlIdfJZ8uYCY',
  datatableConfig: {
    pagingType: 'simple_numbers',
    pageLength: 10,
    lengthMenu: [10, 25, 50],
    processing: true,
    searching: false,
    destroy: true,
    language: {
      lengthMenu: 'Tampilkan _MENU_ data per halaman',
      zeroRecords: 'Tidak ada data',
      info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
      infoEmpty: '',
      infoFiltered: '(disaring dari _MAX_ total data)',
      paginate: {
        previous: "<i class='fa fa-backward'></i>",
        next: "<i class='fa fa-forward'></i>",
        first: "<i class='fa fa-step-forward'></i>",
        last: "<i class='fa fa-step-backward'></i>",
      },
    },
  },
  settingskp: {
    enableBiaya: false,
    enableKualitas: false,
    enableAngkaKredit: false,
    enableInputByReference: false,
    showTahap: false,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
